/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function(){
    var SUPABASE_URL = "https://gbfaazkjmkuqkifexivw.supabase.co";
    var SUPABASE_KEY =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdiZmFhemtqbWt1cWtpZmV4aXZ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyNTE1MTAsImV4cCI6MjA5MjgyNzUxMH0.OSR5bzmgSJWJffu377ypnSrPmkRTP94gXeeIolod9ps";
    var PAGE_SIZE = 8;
    var currentRating = "all";
    var currentSort   = "newest";
    var currentPage = 1;
    var totalPages = 1;
    var starCounts = {};
    var totalReviewCount = 0;
  
    // PostgREST order. Postgres puts NULLs FIRST on DESC, so reviews with no votes (votes = null)
    // were landing at the top of "popular" → nullslast. The extra keys give a stable order for ties,
    // so paging with offset doesn't repeat/skip reviews that share the same votes/date.
    var SORT_ORDER = {
      newest:  "date_created.desc.nullslast,id.desc",
      oldest:  "date_created.asc.nullslast,id.asc",
      popular: "votes.desc.nullslast,date_created.desc.nullslast,id.desc",
    };
  
    var $reviewsEl   = $("#supa-reviews-list");
    var lang         = ($reviewsEl.attr("data-lan") || "de").toLowerCase();
    var langNeeded   = ($reviewsEl.attr("data-lang-needed") || lang).toLowerCase();
    var TRANS_TITLE  = "translated_" + lang + "_title";
    var TRANS_TEXT   = "translated_" + lang + "_comments";
  
    var TIME = {
      justNow:      $reviewsEl.attr("data-time-just-now")       || "Just now",
      oneMinuteAgo: $reviewsEl.attr("data-time-one-minute-ago") || "1 minute ago",
      minutesAgo:   $reviewsEl.attr("data-time-minutes-ago")    || "$1 minutes ago",
      oneHourAgo:   $reviewsEl.attr("data-time-one-hour-ago")   || "1 hour ago",
      hoursAgo:     $reviewsEl.attr("data-time-hours-ago")      || "$1 hours ago",
      yesterday:    $reviewsEl.attr("data-time-yesterday")      || "Yesterday",
      daysAgo:      $reviewsEl.attr("data-time-days-ago")       || "$1 days ago",
      oneWeekAgo:   $reviewsEl.attr("data-time-one-week-ago")   || "1 week ago",
      weeksAgo:     $reviewsEl.attr("data-time-weeks-ago")      || "$1 weeks ago",
      oneMonthAgo:  $reviewsEl.attr("data-time-one-month-ago")  || "1 month ago",
      monthsAgo:    $reviewsEl.attr("data-time-months-ago")     || "$1 months ago",
      oneYearAgo:   $reviewsEl.attr("data-time-one-year-ago")   || "1 year ago",
      yearsAgo:     $reviewsEl.attr("data-time-years-ago")      || "$1 years ago",
    };
  
    var productGroup  = $reviewsEl.attr("data-product-group") || "RGroup_HPro";

    // "Show UK reviews first" (snippets/desk_pdp-reviews-local-first.liquid).
    // Local = location ends with ", <country>" (reviews_local_first_country) or, if no country set,
    // language = reviews_language_needed. Local reviews are paged first, then all the others,
    // each group keeps the selected sort + rating filter.
    var localFirst    = $reviewsEl.attr("data-local-first") === "true";
    var LOCAL_COUNTRY = ($reviewsEl.attr("data-local-first-country") || "").trim().toUpperCase();
    var localCount    = 0;

    function localParams(isLocal) {
      if (LOCAL_COUNTRY) {
        var pattern = "*, " + LOCAL_COUNTRY;
        return isLocal
          ? "&location=ilike." + encodeURIComponent(pattern)
          : "&or=" + encodeURIComponent('(location.is.null,location.not.ilike."' + pattern + '")');
      }
      return isLocal
        ? "&language=eq." + encodeURIComponent(langNeeded)
        : "&or=" + encodeURIComponent("(language.is.null,language.neq." + langNeeded + ")");
    }
  
    var BTN_TRANSLATE = $reviewsEl.attr("data-btn-translate") || "Translate";
    var BTN_REVERT    = $reviewsEl.attr("data-btn-revert")    || "Show original";
    var BTN_LOADING   = $reviewsEl.attr("data-btn-loading")   || "Translating…";
    var WAS_HELPFUL     = $reviewsEl.attr("data-was-helpful")     || "Was this review helpful?";
    var UPVOTED         = $reviewsEl.attr("data-trans-upvoted")   || "Thank you!";
    // Default popup "is this helpful?" label, captured before any vote swaps it to UPVOTED.
    var POPUP_HELPFUL   = ($(".rsp-popup_helpful p").first().text() || "").trim() || WAS_HELPFUL;
    var NO_COMMENTS     = $reviewsEl.attr("data-no-comments")     || "";
    var VERIFIED_BUYER  = $reviewsEl.attr("data-verified-buyer")  || "Verified Buyer";
  
    var TRANSLATE_ICON = "https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Translate.png?v=1780996428";
  
    var TRANSLATE_BTNS_HTML =
      '<div class="rsp_popup-translate_btns">' +
        '<div class="rsp_popup-translate-btn">' +
          '<div class="review_lan-btn_in">' +
            '<span><img src="' + TRANSLATE_ICON + '"></span>' +
            '<span><p>' + BTN_TRANSLATE + '</p></span>' +
          '</div>' +
        '</div>' +
        '<div class="rsp_popup-revert-btn">' +
          '<div class="review_lan-btn_in">' +
            '<span><img src="' + TRANSLATE_ICON + '"></span>' +
            '<span><p>' + BTN_REVERT + '</p></span>' +
          '</div>' +
        '</div>' +
        '<div class="rsp_popup-loading-btn">' +
          '<span>' + BTN_LOADING + '</span>' +
          '<span class="review_loading-loader"></span>' +
        '</div>' +
      '</div>';
  
    var PLAY_ICON_SVG =
      '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none"> <path d="M10.929 6.45833C10.9294 6.627 10.8861 6.79291 10.8034 6.93992C10.7207 7.08692 10.6014 7.21003 10.457 7.29726L1.51018 12.7704C1.35934 12.8628 1.18658 12.9132 1.00974 12.9165C0.832892 12.9198 0.65838 12.8758 0.504223 12.7891C0.351534 12.7037 0.224339 12.5792 0.13572 12.4284C0.047101 12.2775 0.000255128 12.1058 0 11.9309V0.98578C0.000255128 0.810845 0.047101 0.639135 0.13572 0.488308C0.224339 0.33748 0.351534 0.212979 0.504223 0.127608C0.65838 0.040889 0.832892 -0.00310453 1.00974 0.000170359C1.18658 0.00344525 1.35934 0.0538699 1.51018 0.146237L10.457 5.61941C10.6014 5.70664 10.7207 5.82974 10.8034 5.97675C10.8861 6.12376 10.9294 6.28966 10.929 6.45833Z" fill="white"></path> </svg>';
  
    var POPUP_PLAY_ICON_SVG =
      '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none"> <path d="M10.929 6.45833C10.9294 6.627 10.8861 6.79291 10.8034 6.93992C10.7207 7.08692 10.6014 7.21003 10.457 7.29726L1.51018 12.7704C1.35934 12.8628 1.18658 12.9132 1.00974 12.9165C0.832892 12.9198 0.65838 12.8758 0.504223 12.7891C0.351534 12.7037 0.224339 12.5792 0.13572 12.4284C0.047101 12.2775 0.000255128 12.1058 0 11.9309V0.98578C0.000255128 0.810845 0.047101 0.639135 0.13572 0.488308C0.224339 0.33748 0.351534 0.212979 0.504223 0.127608C0.65838 0.040889 0.832892 -0.00310453 1.00974 0.000170359C1.18658 0.00344525 1.35934 0.0538699 1.51018 0.146237L10.457 5.61941C10.6014 5.70664 10.7207 5.82974 10.8034 5.97675C10.8861 6.12376 10.9294 6.28966 10.929 6.45833Z" fill="white"></path> </svg>';
  
    var STAR_IMGS = {
      5: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars5.png?v=1778831784",
      4: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars4.png?v=1778831784",
      3: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars3.png?v=1778831783",
      2: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars2.png?v=1778831784",
      1: "https://cdn.shopify.com/s/files/1/0571/4051/0858/files/stars1.png?v=1778831784",
    };
    var BADGE_ICON =
      "https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Official_Icon_bd26e28f-35f3-49f7-a223-fb964b37fae7.png?v=1780989263";
  
    var SUPABASE_HEADERS = {
      apikey: SUPABASE_KEY,
      Authorization: "Bearer " + SUPABASE_KEY,
    };
  
    function thumbUrl(src) {
      return "https://media.reviews.co.uk/resize/create?format=jpg&width=400&height=400&src=" + encodeURIComponent(src);
    }
  
    function timeAgo(dateStr) {
      if (!dateStr) return "";
      var diff = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
      if (diff < 60)  return TIME.justNow;
      var m = Math.floor(diff / 60);
      if (m < 60)     return m === 1 ? TIME.oneMinuteAgo : TIME.minutesAgo.replace("$1", m);
      var h = Math.floor(diff / 3600);
      if (h < 24)     return h === 1 ? TIME.oneHourAgo   : TIME.hoursAgo.replace("$1", h);
      var d = Math.floor(diff / 86400);
      if (d < 7)      return d === 1 ? TIME.yesterday     : TIME.daysAgo.replace("$1", d);
      var w = Math.floor(d / 7);
      if (w < 5)      return w === 1 ? TIME.oneWeekAgo   : TIME.weeksAgo.replace("$1", w);
      var mo = Math.floor(d / 30);
      if (mo < 12)    return mo === 1 ? TIME.oneMonthAgo  : TIME.monthsAgo.replace("$1", mo);
      var yr = Math.floor(d / 365);
      return yr === 1 ? TIME.oneYearAgo : TIME.yearsAgo.replace("$1", yr);
    }
  
    function escapeAttr(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;");
    }
  
    function getImages(r) {
      var imgSrc = r.published_images || r.unpublished_images || "";
      var images = [];
      if (imgSrc) {
        try {
          images = typeof imgSrc === "string" ? JSON.parse(imgSrc) : imgSrc;
        } catch (e) {
          var str = String(imgSrc);
          var sep = str.indexOf(";") !== -1 ? ";" : ",";
          images = $.map(str.split(sep), function (s) { return s.trim() || null; });
        }
      }
      if (!Array.isArray(images)) images = [];
      images = $.map(images, function (img) {
        var url = typeof img === "string" ? img : (img.src || img.thumbnail || img.url || img.image || "");
        return /\.(heic|heif)$/i.test(url) ? null : (url || null);
      });
      return images;
    }
  
    function getVideos(r) {
      var vidSrc = r.published_videos || r.unpublished_videos || "";
      var videos = [];
      if (vidSrc) {
        try {
          videos = typeof vidSrc === "string" ? JSON.parse(vidSrc) : vidSrc;
        } catch (e) {
          var str = String(vidSrc);
          var sep = str.indexOf(";") !== -1 ? ";" : ",";
          videos = $.map(str.split(sep), function (s) { return s.trim() || null; });
        }
      }
      if (!Array.isArray(videos)) videos = [];
      return $.map(videos, function (vid) {
        var url = typeof vid === "string" ? vid : (vid.src || vid.url || vid.video || "");
        return url || null;
      });
    }
  
    function getMediaItems(r) {
      var items = [];
      $.each(getImages(r), function (_, url) { items.push({ type: "image", url: url }); });
      $.each(getVideos(r), function (_, url) { items.push({ type: "video", url: url }); });
      return items;
    }
  
    // Country flag next to .pdp_supa-review-country / .rso_popup-country (inline SVG, FLAG_SVGS below).
    // Code taken from: location ending ", XX" → location ending with a country name → review language.
    var LANG_TO_FLAG = {
      en:"gb", de:"de", da:"dk", sv:"se", nb:"no", no:"no", nl:"nl", fr:"fr", pl:"pl", lt:"lt",
      lv:"lv", et:"ee", fi:"fi", es:"es", it:"it", pt:"pt", cs:"cz", sk:"sk", sl:"si", hu:"hu",
      ro:"ro", bg:"bg", hr:"hr", sr:"rs", el:"gr", tr:"tr", uk:"ua", ru:"ru", is:"is", ja:"jp",
      ko:"kr", zh:"cn", he:"il", hi:"in", vi:"vn", th:"th", id:"id", ms:"my", kk:"kz", ka:"ge",
      be:"by", bs:"ba", mk:"mk", sq:"al", hy:"am", az:"az", ur:"pk", bn:"bd"
    };
    var NAME_TO_FLAG = {
      "united kingdom":"gb", "uk":"gb", "great britain":"gb", "england":"gb", "scotland":"gb", "wales":"gb",
      "united states":"us", "usa":"us", "germany":"de", "deutschland":"de", "denmark":"dk", "danmark":"dk",
      "sweden":"se", "sverige":"se", "norway":"no", "netherlands":"nl", "nederland":"nl", "belgium":"be",
      "belgië":"be", "belgique":"be", "france":"fr", "poland":"pl", "polska":"pl", "lithuania":"lt",
      "lietuva":"lt", "latvia":"lv", "estonia":"ee", "finland":"fi", "spain":"es", "italy":"it",
      "portugal":"pt", "austria":"at", "österreich":"at", "switzerland":"ch", "schweiz":"ch",
      "ireland":"ie", "czech republic":"cz", "luxembourg":"lu", "canada":"ca", "australia":"au"
    };

    function reviewFlagCode(location, language) {
      var loc = String(location || "").trim();
      var m = loc.match(/,\s*([A-Za-z]{2})\s*$/) || loc.match(/^([A-Za-z]{2})$/);
      if (m) {
        var c = m[1].toLowerCase();
        return c === "uk" ? "gb" : c;
      }
      var name = loc.split(",").pop().trim().toLowerCase();
      if (NAME_TO_FLAG[name]) return NAME_TO_FLAG[name];
      return LANG_TO_FLAG[String(language || "").toLowerCase()] || "";
    }

    var STORE_TO_FLAG = {
      "desktronic.de":"de", "desktronic.lt":"lt", "desktronic.fr":"fr", "desktronic.pl":"pl",
      "desktronic.dk":"dk", "desktronic.se-mk2zq9b":"se", "desktronic.be":"be", "desktronic.nl":"nl",
      "desktronic.co.uk":"gb", "desktronic.com":"us", "desktronic.cz":"cz"
    };
    var FLAG_TO_CAPITAL = {
      gb:"London", de:"Berlin", lt:"Vilnius", dk:"Copenhagen", se:"Stockholm", no:"Oslo", nl:"Amsterdam",
      be:"Brussels", fr:"Paris", pl:"Warsaw", lv:"Riga", ee:"Tallinn", fi:"Helsinki", es:"Madrid", it:"Rome",
      pt:"Lisbon", cz:"Prague", sk:"Bratislava", si:"Ljubljana", hu:"Budapest", ro:"Bucharest", bg:"Sofia",
      hr:"Zagreb", gr:"Athens", ua:"Kyiv", is:"Reykjavik", at:"Vienna", ch:"Bern", ie:"Dublin",
      lu:"Luxembourg", us:"Washington", ca:"Ottawa", au:"Canberra"
    };

    function cleanLocationPart(v) {
      var s = String(v || "").replace(/^[\s,"'“”„‘’]+|[\s,"'“”„‘’]+$/g, "").replace(/\s+/g, " ").trim();
      return /^(null|undefined|none|n\/a|not found|unknown|-+)?$/i.test(s) ? "" : s;
    }

    function partFlag(part) {
      if (/^[A-Za-z]{2}$/.test(part)) return part.toLowerCase().replace(/^uk$/, "gb");
      return NAME_TO_FLAG[part.toLowerCase().replace(/^(the |(federal |hellenic |slovak |czech |islamic )?republic of |kingdom of (the )?|grand duchy of )+/, "")];
    }

    function countryLabel(location, language, store) {
      var fallback = LANG_TO_FLAG[String(language || "").toLowerCase()] || STORE_TO_FLAG[String(store || "").toLowerCase()] || "";
      var withCapital = function (flag) {
        if (!flag) return "";
        var code = flag === "gb" ? "UK" : flag.toUpperCase();
        return FLAG_TO_CAPITAL[flag] ? FLAG_TO_CAPITAL[flag] + ", " + code : code;
      };
      var parts = $.grep($.map(String(location || "").split(","), cleanLocationPart), Boolean);
      if (!parts.length) return withCapital(fallback);
      var prev = parts.length > 1 ? parts[parts.length - 2] : "";
      var flag = (prev && !/^[A-Za-z]{2}$/.test(prev) && partFlag(prev)) || partFlag(parts[parts.length - 1]);
      if (flag) {
        var city = $.grep(parts.slice(0, -1), function (p) { return !partFlag(p); });
        return city.length ? city.join(", ") + ", " + (flag === "gb" ? "UK" : flag.toUpperCase()) : withCapital(flag);
      }
      return parts.join(", ") + (fallback ? ", " + (fallback === "gb" ? "UK" : fallback.toUpperCase()) : "");
    }

    function countryHtml(label, language, names) {
      var code = (String(label || "").match(/(?:^|,)\s*([A-Za-z]{2})\s*$/) || [])[1];
      if (!code) return "";
      var text = (names && (names[lang] || names.en)) || code.toUpperCase();
      return flagHtml(label, language) + "<span>" + $("<div>").text(text).html() + "</span>";
    }

    // Flag icons — Figma "Design system - Assets" 1842:1078 (24×18 artboard, rendered 16×12).
    // Only these markets have an icon; other countries show no flag.
    var FLAG_SVGS = {
      at: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-at-0)\"><g clip-path=\"url(#fl-at-1)\"><path d=\"M0 6H24V12H0V6Z\" fill=\"white\" /><path d=\"M0 0H24V6H0V0ZM0 12H24V18H0V12Z\" fill=\"#C8102E\" /></g></g><defs><clipPath id=\"fl-at-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-at-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      be: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-be-0)\"><g clip-path=\"url(#fl-be-1)\"><g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0H7.99875V18H0V0Z\" fill=\"#000001\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.99878 0H16.0013V18H7.99878V0Z\" fill=\"#FFD90C\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0012 0H24V18H16.0012V0Z\" fill=\"#F31830\" /></g></g></g><defs><clipPath id=\"fl-be-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-be-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      de: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-de-0)\"><g clip-path=\"url(#fl-de-1)\"><path d=\"M0 12H24V18H0V12Z\" fill=\"#FFCC00\" /><path d=\"M0 0H24V6H0V0Z\" fill=\"#000001\" /><path d=\"M0 6H24V12H0V6Z\" fill=\"#FF0000\" /></g></g><defs><clipPath id=\"fl-de-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-de-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      dk: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-dk-0)\"><g clip-path=\"url(#fl-dk-1)\"><path d=\"M0 0H24.0037V18H0V0Z\" fill=\"#C8102E\" /><path d=\"M7.71387 0H10.2864V18H7.71387V0Z\" fill=\"white\" /><path d=\"M0 7.71387H24.0037V10.2864H0V7.71387Z\" fill=\"white\" /></g></g><defs><clipPath id=\"fl-dk-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-dk-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      fr: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-fr-0)\"><g clip-path=\"url(#fl-fr-1)\"><path d=\"M0 0H24V18H0V0Z\" fill=\"white\" /><path d=\"M0 0H7.99875V18H0V0Z\" fill=\"#000091\" /><path d=\"M16.0012 0H24V18H16.0012V0Z\" fill=\"#E1000F\" /></g></g><defs><clipPath id=\"fl-fr-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-fr-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      gb: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-gb-0)\"><g clip-path=\"url(#fl-gb-1)\"><path d=\"M0 0H24V18H0V0Z\" fill=\"#012169\" /><path d=\"M2.8125 0L11.9625 6.7875L21.075 0H24V2.325L15 9.0375L24 15.7125V18H21L12 11.2875L3.0375 18H0V15.75L8.9625 9.075L0 2.4V0H2.8125Z\" fill=\"white\" /><path d=\"M15.9 10.5375L24 16.5V18L13.8375 10.5375H15.9ZM9 11.2875L9.225 12.6L2.025 18H0L9 11.2875ZM24 0V0.1125L14.6625 7.1625L14.7375 5.5125L22.125 0H24ZM0 0L8.9625 6.6H6.7125L0 1.575V0Z\" fill=\"#C8102E\" /><path d=\"M9.0375 0V18H15.0375V0H9.0375ZM0 6V12H24V6H0Z\" fill=\"white\" /><path d=\"M0 7.2375V10.8375H24V7.2375H0ZM10.2375 0V18H13.8375V0H10.2375Z\" fill=\"#C8102E\" /></g></g><defs><clipPath id=\"fl-gb-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-gb-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      lt: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-lt-0)\"><g clip-path=\"url(#fl-lt-1)\"><g><path d=\"M24.0003 0H0V17.9223H24.0003V0Z\" fill=\"#006A44\" /><path d=\"M24.0003 12.0273H0V18.0006H24.0003V12.0273Z\" fill=\"#C1272D\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0H24.0007V5.97331H0V0Z\" fill=\"#FDB913\" /></g></g></g><defs><clipPath id=\"fl-lt-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-lt-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      lu: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-lu-0)\"><g clip-path=\"url(#fl-lu-1)\"><path d=\"M0 0H24V6H0V0Z\" fill=\"#ED2939\" /><path d=\"M0 6H24V12H0V6Z\" fill=\"white\" /><path d=\"M0 12H24V18H0V12Z\" fill=\"#00A1DE\" /></g></g><defs><clipPath id=\"fl-lu-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-lu-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      nl: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-nl-0)\"><g clip-path=\"url(#fl-nl-1)\"><path d=\"M0 0H24V6H0V0Z\" fill=\"#AE1C28\" /><path d=\"M0 6H24V12H0V6Z\" fill=\"white\" /><path d=\"M0 12H24V18H0V12Z\" fill=\"#21468B\" /></g></g><defs><clipPath id=\"fl-nl-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-nl-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      pl: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-pl-0)\"><path d=\"M23.5 0.5V17.5H0.5V0.5H23.5Z\" fill=\"white\" stroke=\"#E6E8EA\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 18H0V9H24V18Z\" fill=\"#DC143C\" /></g><defs><clipPath id=\"fl-pl-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      se: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-se-0)\"><g clip-path=\"url(#fl-se-1)\"><path d=\"M0 0H24V18H0V0Z\" fill=\"#005293\" /><path d=\"M6.6 0V7.2H0V10.8H6.6V18H10.2V10.8H24V7.2H10.2V0H6.6Z\" fill=\"#FECB00\" /></g></g><defs><clipPath id=\"fl-se-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath><clipPath id=\"fl-se-1\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>",
      us: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 24 18\" fill=\"none\" aria-hidden=\"true\"><g clip-path=\"url(#fl-us-0)\"><g><path d=\"M0 0H24V18H0\" fill=\"#BD3D44\" /><path d=\"M0 2.07373H24H0ZM0 4.83748H24H0ZM0 7.61248H24H0ZM0 10.3875H24H0ZM0 13.1625H24H0ZM0 15.9375H24H0Z\" fill=\"black\" /><path d=\"M0 1.37988V2.76738H24V1.37988H0ZM0 4.14363V5.53113H24V4.14363H0ZM0 6.91863V8.30613H24V6.91863H0ZM0 9.69363V11.0811H24V9.69363H0ZM0 12.4686V13.8561H24V12.4686H0ZM0 15.2436V16.6311H24V15.2436H0Z\" fill=\"white\" /><path d=\"M0 0H13.68V9.69375H0\" fill=\"#192F5D\" /><g><path d=\"M12.5251 8.1751L12.8626 9.1876L12.0001 8.5501H13.0501L12.1876 9.1876L12.5251 8.1751ZM10.2751 8.1751L10.6126 9.1876L9.7501 8.5501H10.8001L9.9376 9.1876L10.2751 8.1751ZM7.9876 8.1751L8.3251 9.1876L7.4626 8.5501H8.5126L7.6501 9.1876L7.9876 8.1751ZM5.7001 8.1751L6.0376 9.1876L5.1751 8.5501H6.2251L5.3626 9.1876L5.7001 8.1751ZM3.4126 8.1751L3.7501 9.1876L2.8876 8.5501H3.9376L3.0751 9.1876L3.4126 8.1751ZM1.1251 8.1751L1.4626 9.1876L0.600098 8.5501H1.6501L0.787598 9.1876L1.1251 8.1751ZM11.4001 7.2001L11.7376 8.2126L10.8751 7.5751H11.9251L11.0626 8.2126L11.4001 7.2001ZM9.1126 7.2001L9.4501 8.2126L8.5876 7.5751H9.6376L8.7751 8.2126L9.1126 7.2001ZM6.8626 7.2001L7.2001 8.2126L6.3376 7.5751H7.3876L6.5251 8.2126L6.8626 7.2001ZM4.5751 7.2001L4.9126 8.2126L4.0501 7.5751H5.1001L4.2376 8.2126L4.5751 7.2001ZM2.2876 7.2001L2.6251 8.2126L1.7626 7.5751H2.8126L1.9501 8.2126L2.2876 7.2001ZM12.5251 6.2251L12.8626 7.2376L12.0001 6.6001H13.0501L12.1876 7.2376L12.5251 6.2251ZM10.2751 6.2251L10.6126 7.2376L9.7501 6.6001H10.8001L9.9376 7.2376L10.2751 6.2251ZM7.9876 6.2251L8.3251 7.2376L7.4626 6.6001H8.5126L7.6501 7.2376L7.9876 6.2251ZM5.7001 6.2251L6.0376 7.2376L5.1751 6.6001H6.2251L5.3626 7.2376L5.7001 6.2251ZM3.4126 6.2251L3.7501 7.2376L2.8876 6.6001H3.9376L3.0751 7.2376L3.4126 6.2251ZM1.1251 6.2251L1.4626 7.2376L0.600098 6.6001H1.6501L0.787598 7.2376L1.1251 6.2251ZM11.4001 5.2876L11.7376 6.3001L10.8751 5.6626H11.9251L11.0626 6.3001L11.4001 5.2876ZM9.1126 5.2876L9.4501 6.3001L8.5876 5.6626H9.6376L8.7751 6.3001L9.1126 5.2876ZM6.8626 5.2876L7.2001 6.3001L6.3376 5.6626H7.3876L6.5251 6.3001L6.8626 5.2876ZM4.5751 5.2876L4.9126 6.3001L4.0501 5.6626H5.1001L4.2376 6.3001L4.5751 5.2876ZM2.2876 5.2876L2.6251 6.3001L1.7626 5.6626H2.8126L1.9501 6.3001L2.2876 5.2876ZM12.5251 4.3126L12.8626 5.3251L12.0001 4.6876H13.0501L12.1876 5.3251L12.5251 4.3126ZM10.2751 4.3126L10.6126 5.3251L9.7501 4.6876H10.8001L9.9376 5.3251L10.2751 4.3126ZM7.9876 4.3126L8.3251 5.3251L7.4626 4.6876H8.5126L7.6501 5.3251L7.9876 4.3126ZM5.7001 4.3126L6.0376 5.3251L5.1751 4.6876H6.2251L5.3626 5.3251L5.7001 4.3126ZM3.4126 4.3126L3.7501 5.3251L2.8876 4.6876H3.9376L3.0751 5.3251L3.4126 4.3126ZM1.1251 4.3126L1.4626 5.3251L0.600098 4.6876H1.6501L0.787598 5.3251L1.1251 4.3126ZM11.4001 3.3376L11.7376 4.3501L10.8751 3.7126H11.9251L11.0626 4.3501L11.4001 3.3376ZM9.1126 3.3376L9.4501 4.3501L8.5876 3.7126H9.6376L8.7751 4.3501L9.1126 3.3376ZM6.8626 3.3376L7.2001 4.3501L6.3376 3.7126H7.3876L6.5251 4.3501L6.8626 3.3376ZM4.5751 3.3376L4.9126 4.3501L4.0501 3.7126H5.1001L4.2376 4.3501L4.5751 3.3376ZM2.2876 3.3376L2.6251 4.3501L1.7626 3.7126H2.8126L1.9501 4.3501L2.2876 3.3376ZM12.5251 2.3626L12.8626 3.3751L12.0001 2.7376H13.0501L12.1876 3.3751L12.5251 2.3626ZM10.2751 2.3626L10.6126 3.3751L9.7501 2.7376H10.8001L9.9376 3.3751L10.2751 2.3626ZM7.9876 2.3626L8.3251 3.3751L7.4626 2.7376H8.5126L7.6501 3.3751L7.9876 2.3626ZM5.7001 2.3626L6.0376 3.3751L5.1751 2.7376H6.2251L5.3626 3.3751L5.7001 2.3626ZM3.4126 2.3626L3.7501 3.3751L2.8876 2.7376H3.9376L3.0751 3.3751L3.4126 2.3626ZM1.1251 2.3626L1.4626 3.3751L0.600098 2.7376H1.6501L0.787598 3.3751L1.1251 2.3626ZM11.4001 1.3876L11.7376 2.4001L10.8751 1.7626H11.9251L11.0626 2.4001L11.4001 1.3876ZM9.1126 1.3876L9.4501 2.4001L8.5876 1.7626H9.6376L8.7751 2.4001L9.1126 1.3876ZM6.8626 1.3876L7.2001 2.4001L6.3376 1.7626H7.3876L6.5251 2.4001L6.8626 1.3876ZM4.5751 1.3876L4.9126 2.4001L4.0501 1.7626H5.1001L4.2376 2.4001L4.5751 1.3876ZM2.2876 1.3876L2.6251 2.4001L1.7626 1.7626H2.8126L1.9501 2.4001L2.2876 1.3876ZM12.5251 0.412598L12.8626 1.4251L12.0001 0.787598H13.0501L12.1876 1.4251L12.5251 0.412598ZM10.2751 0.412598L10.6126 1.4251L9.7501 0.787598H10.8001L9.9376 1.4251L10.2751 0.412598ZM7.9876 0.412598L8.3251 1.4251L7.4626 0.787598H8.5126L7.6501 1.4251L7.9876 0.412598ZM5.7001 0.412598L6.0376 1.4251L5.1751 0.787598H6.2251L5.3626 1.4251L5.7001 0.412598ZM3.4126 0.412598L3.7501 1.4251L2.8876 0.787598H3.9376L3.0751 1.4251L3.4126 0.412598ZM1.1251 0.412598L1.4626 1.4251L0.600098 0.787598H1.6501L0.787598 1.4251L1.1251 0.412598Z\" fill=\"white\" /></g></g></g><defs><clipPath id=\"fl-us-0\"><rect width=\"24\" height=\"18\" fill=\"white\" /></clipPath></defs></svg>"
    };

    function flagHtml(location, language) {
      var code = reviewFlagCode(location, language);
      var svg = FLAG_SVGS[code];
      return svg ? '<span class="pdp_supa-review-flag" title="' + code.toUpperCase() + '">' + svg + "</span>" : "";
    }

    function isAlreadyInTargetLang(location) {
      if (!location) return false;
      var match = location.match(/(?:^|,)\s*([A-Za-z]{2})\s*$/);
      return match ? match[1].toLowerCase() === lang : false;
    }
  
    function differs(a, b) {
      return String(a || "").trim().toLowerCase() !== String(b || "").trim().toLowerCase();
    }

    function hasRealTranslation(r) {
      return (!!r[TRANS_TEXT] && differs(r[TRANS_TEXT], r.comments)) ||
             (!!r[TRANS_TITLE] && differs(r[TRANS_TITLE], r.review_title));
    }

    function reviewNeedsTranslate(reviewLang, location) {
      if (reviewLang) return reviewLang.toLowerCase() !== langNeeded;
      return !isAlreadyInTargetLang(location);
    }
  
    function baseParams(rating) {
      var p = "&product_lookup=eq." + productGroup;
      if (!rating || rating === "all") return p;
      if (Array.isArray(rating)) {
        if (rating.length === 1) {
          p += "&rating=eq." + rating[0];
        } else {
          p += "&rating=in.(" + rating.join(",") + ")";
        }
      } else {
        p += "&rating=eq." + rating;
      }
      return p;
    }
  
    function fetchCount(rating, extra) {
      var url =
        SUPABASE_URL +
        "/rest/v1/" +
        encodeURIComponent("Reviews.io Original data") +
        "?select=rating" +
        baseParams(rating) +
        (extra || "") +
        "&limit=1";
      return $.ajax({
        url: url,
        headers: $.extend({}, SUPABASE_HEADERS, { Prefer: "count=exact" }),
      }).then(function (_data, _status, xhr) {
        var range = xhr.getResponseHeader("Content-Range");
        return range ? parseInt(range.split("/")[1], 10) || 0 : 0;
      });
    }
  
    function fetchRange(rating, extra, offset, limit) {
      var url =
        SUPABASE_URL +
        "/rest/v1/" +
        encodeURIComponent("Reviews.io Original data") +
        "?select=id,review_title,comments,rating,date_created,author,location,store,country_names,votes,unpublished_images,published_images,language," + TRANS_TITLE + "," + TRANS_TEXT +
        baseParams(rating) +
        (extra || "") +
        "&order=" + (SORT_ORDER[currentSort] || "date_created.desc") +
        "&limit=" + limit +
        "&offset=" + offset;
      return $.ajax({ url: url, headers: SUPABASE_HEADERS });
    }

    // One page of reviews. With localFirst the list is [all local…, all others…]:
    // a page can fall fully in one group or straddle both (then two requests are merged).
    function fetchPage(rating, page) {
      var offset = (page - 1) * PAGE_SIZE;
      if (!localFirst) return fetchRange(rating, "", offset, PAGE_SIZE);

      var fromLocal = Math.max(Math.min(localCount - offset, PAGE_SIZE), 0);
      var fromOther = PAGE_SIZE - fromLocal;
      var otherOffset = Math.max(offset - localCount, 0);

      var reqLocal = fromLocal > 0 ? fetchRange(rating, localParams(true), offset, fromLocal) : $.Deferred().resolve([]).promise();
      var reqOther = fromOther > 0 ? fetchRange(rating, localParams(false), otherOffset, fromOther) : $.Deferred().resolve([]).promise();

      return $.when(reqLocal, reqOther).then(function (a, b) {
        // $.ajax resolves with [data, status, xhr]; the Deferred stub with the array itself
        var local = Array.isArray(a) && Array.isArray(a[0]) ? a[0] : a;
        var other = Array.isArray(b) && Array.isArray(b[0]) ? b[0] : b;
        return (local || []).concat(other || []);
      });
    }
  
    function fetchGalleryReviews() {
      var url =
        SUPABASE_URL +
        "/rest/v1/" +
        encodeURIComponent("Reviews.io Original data") +
        "?select=id,votes,review_title,comments,rating,date_created,author,location,store,country_names,published_images,unpublished_images,published_videos,unpublished_videos,language," + TRANS_TITLE + "," + TRANS_TEXT +
        "&product_lookup=eq." + productGroup +
        "&or=(published_images.not.is.null,unpublished_images.not.is.null,published_videos.not.is.null,unpublished_videos.not.is.null)" +
        "&order=date_created.desc" +
        "&limit=50";
      return $.ajax({ url: url, headers: SUPABASE_HEADERS });
    }
  
    function getVotedSet() {
      var match = document.cookie.match(/(?:^|;\s*)sr_votes=([^;]*)/);
      return match ? new Set(match[1].split(",").filter(Boolean)) : new Set();
    }
  
    function markVoted(id) {
      var set = getVotedSet();
      set.add(String(id));
      var expires = new Date(Date.now() + 365 * 86400 * 1000).toUTCString();
      document.cookie = "sr_votes=" + Array.from(set).join(",") + "; expires=" + expires + "; path=/";
    }
  
    function renderReview(r) {
      var rating = Math.min(Math.max(Math.round(r.rating) || 0, 1), 5);
      var date = timeAgo(r.date_created);
      var images = getImages(r);
  
      var starsHtml =
        '<img loading="lazy" class="pdp_supa-review-stars" data="' + rating + '" src="' + STAR_IMGS[rating] + '">';
  
      var mediaHtml = images.length
        ? $.map(images.slice(0, 5), function (img) {
            return '<img loading="lazy" src="' + img + '" alt="">';
          }).join("")
        : "";
  
      return (
        '<div class="pdp_supa-review" data-rating="' + rating + '" data-language="' + escapeAttr(r.language || "") + '" data-review-id="' + escapeAttr(r.id || "") + '">' +
          '<div class="pdp_supa-review-info">' +
            '<div>' +
            '<div class="Desktop_only">' +
              starsHtml +
            '</div>' +
            '<p class="pdp_supa-review-name">' + (r.author || "") + "</p>" +
            (function(){ var country = countryLabel(r.location, r.language, r.store); return country ? '<p class="pdp_supa-review-country" data-label="' + escapeAttr(country) + '" data-names="' + escapeAttr(r.country_names ? JSON.stringify(r.country_names) : "") + '">' + countryHtml(country, r.language, r.country_names) + "</p>" : ""; }()) +
            '<p class="pdp_supa-review-verif">' +
              '<span><img src="' + BADGE_ICON + '" alt="badge icon"></span>' +
              '<span>' + VERIFIED_BUYER + '</span>' +
            "</p>" +
            '</div>' +
            '<div class="Mobile_only">' +
              '<div class="Mobile_only pdp_supa-stars__mobile">'+ starsHtml +'</div>' +
              (date ? '<p class="pdp_supa-review-date Mobile_only">' + date + "</p>" : "") +
            '</div>' +
          "</div>" +
          '<div class="pdp_supa-review-content__outer">' +
            '<div class="pdp_supa-review-content">' +
              '<div class="pdp_supa-review-content-left">' +
                (r[TRANS_TITLE] || r.review_title ? '<p class="pdp_supa-review-title translatedCont">' + (r[TRANS_TITLE] || r.review_title) + "</p>" : "") +
                (r[TRANS_TEXT] || r.comments || !(r.review_title || r[TRANS_TITLE])
                  ? '<div class="pdp_supa-review-text translatedCont"><p>' + (r[TRANS_TEXT] || r.comments || NO_COMMENTS) + "</p></div>"
                  : "") +
                (r[TRANS_TITLE] ? (r.review_title ? '<p class="pdp_supa-review-title originalCont">' + r.review_title + "</p>" : "") : "") +
                (r[TRANS_TEXT]  ? '<div class="pdp_supa-review-text originalCont"><p>' + (r.comments || "") + "</p></div>" : "") +
                (hasRealTranslation(r) && reviewNeedsTranslate(r.language, r.location) ? TRANSLATE_BTNS_HTML : "") +
                '<div class="pdp_supa-reviews-media">' + mediaHtml + "</div>" +
              "</div>" +
              '<div class="pdp_supa-review-content-right Desktop_only">' +
                  (date ? '<p class="pdp_supa-review-date">' + date + "</p>" : "") +
              "</div>" +
            "</div>" +
            '<div class="pdp_supa-review-footer">' +
                "<div>" +
                "</div>" +
                "<div>" +
                  (function() {
                    var voted = getVotedSet().has(String(r.id));
                    return '<div class="pdp_supa-review-social' + (voted ? " voted" : "") + '">' +
                      "<div><p>" + (voted ? UPVOTED : WAS_HELPFUL) + "</p></div>" +
                      '<div class="pdp_supa-review-rate-review" data-review-id="' + r.id + '">' +
                        '<span><img src="https://cdn.shopify.com/s/files/1/0707/1534/3069/files/Thumbs_Up_Icon_3f2e95d6-cb9b-4d13-a0de-1ba315b7f0f3.png?v=1781003523"></span>' +
                        "<span>" + (r.votes || 0) + "</span>" +
                      "</div>" +
                    "</div>";
                  })() +
                "</div>" +
            "</div>" +

          "</div>" +
        "</div>"
      );
    }
  
    function renderGallery(reviews) {
      galleryReviews = reviews;
      var $container = $(".pdp_supa-reviews-gallery");
      if (!$container.length) return;
  
      var cells = [];
      $.each(reviews, function (idx, r) {
        var items = getMediaItems(r);
        if (!items.length) return;
  
        var first  = items[0];
        var date   = timeAgo(r.date_created);
        var rating = Math.min(Math.max(Math.round(r.rating) || 0, 1), 5);
  
        var thumbHtml = first.type === "video"
          ? '<div class="pdp-gallery-video-thumb">' +
              '<video class="pdp-gallery-video-el" src="' + first.url + '" muted preload="metadata" playsinline></video>' +
              '<div class="pdp-gallery-play-icon">' + PLAY_ICON_SVG + '</div>' +
            '</div>'
          : '<img loading="lazy" decoding="async" src="' + thumbUrl(first.url) + '" alt="" onerror="$(this).closest(\'.pdp_supa-reviews-gallery-cell\').hide()">';
  
        cells.push(
          '<div class="pdp_supa-reviews-gallery-cell"' +
            ' data-gallery-index="' + idx + '"' +
            ' data-name="'        + escapeAttr(r.author)            + '"' +
            ' data-title="'       + escapeAttr(r.review_title)      + '"' +
            ' data-text="'        + escapeAttr(r.comments)          + '"' +
            ' data-trans-text="'  + escapeAttr(r[TRANS_TEXT] || "") + '"' +
            ' data-trans-title="' + escapeAttr(r[TRANS_TITLE] || "") + '"' +
            ' data-date="'        + escapeAttr(date)                + '"' +
            ' data-city="'        + escapeAttr(r.location)          + '"' +
            ' data-language="'    + escapeAttr(r.language || "")    + '"' +
            ' data-rating="'      + rating                          + '"' +
            ' data-media="'       + escapeAttr(JSON.stringify(items)) + '">' +
            thumbHtml +
          "</div>"
        );
      });
  
      $container.html(cells.join(""));
      $(".pdp_supa-reviews-gallery-slider").toggle(cells.length > 0);
      initGalleryVideoThumbs();
      gallerySliderIndex = 0;
      setTimeout(updateGalleryArrows, 100);
    }
  
    function initGalleryVideoThumbs() {
      $(".pdp-gallery-video-el").each(function () {
        var v = this;
        if (v.readyState >= 1) {
          v.currentTime = 0.001;
        } else {
          $(v).on("loadedmetadata.galleryThumb", function () {
            v.currentTime = 0.001;
            $(v).off("loadedmetadata.galleryThumb");
          });
        }
      });
    }
  
    function updateGalleryArrows() {
      var $wrapper  = $(".pdp_supa-reviews-gallery-wrapper");
      if (!$wrapper.length) return;
      var scrollLeft = $wrapper.scrollLeft();
      var maxScroll  = $wrapper[0].scrollWidth - $wrapper[0].clientWidth;
      var noOverflow = maxScroll <= 0;
      $wrapper.toggleClass("fullwidth", noOverflow);
      $(".pdp_supa-reviews-nav.prevArr, .pdp_supa-reviews-nav.nextArr").toggle(!noOverflow);
      if (!noOverflow) {
        $(".pdp_supa-reviews-nav.prevArr").toggleClass("disabledsup", scrollLeft <= 0);
        $(".pdp_supa-reviews-nav.nextArr").toggleClass("disabledsup", scrollLeft >= maxScroll - 1);
      }
    }
  
    function scrollGalleryToIndex(index) {
      var $wrapper = $(".pdp_supa-reviews-gallery-wrapper");
      var $cells   = $(".pdp_supa-reviews-gallery-cell");
      if (!$wrapper.length || !$cells.length) return;
      index = Math.max(0, Math.min(index, $cells.length - 1));
      gallerySliderIndex = index;
      var cellLeft = $cells.eq(index).offset().left - $wrapper.offset().left + $wrapper.scrollLeft();
      $wrapper[0].scrollLeft = cellLeft;
    }
  
    function getPageNumbers(current, total) {
      if (total <= 10) {
        var all = [];
        for (var i = 1; i <= total; i++) all.push(i);
        return all;
      }
      var winStart = Math.max(1, current - 3);
      var winEnd   = Math.min(total, current + 3);
      if (winEnd - winStart < 6) {
        if (winStart === 1) winEnd = Math.min(total, 7);
        else if (winEnd === total) winStart = Math.max(1, total - 6);
      }
      var pages = [];
      if (winStart > 1) {
        pages.push(1);
        if (winStart > 2) pages.push("...");
      }
      for (var i = winStart; i <= winEnd; i++) pages.push(i);
      if (winEnd < total) {
        if (winEnd < total - 1) pages.push("...");
        pages.push(total);
      }
      return pages;
    }
  
    function renderPagination() {
      var $el = $("#supra-reviews-pagination");
      if (!$el.length) return;
      if (totalPages <= 1) { $el.html(""); return; }
  
      var ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none"><path d="M0.218595 0.220451C0.511035 -0.0726323 0.985896 -0.0736795 1.27914 0.218498L8.11996 7.04369C8.2609 7.18438 8.33969 7.3758 8.33969 7.57494C8.33964 7.77388 8.26067 7.9646 8.11996 8.10522L1.27914 14.9304C0.985917 15.2229 0.51113 15.2226 0.218592 14.9294C-0.0737797 14.6362 -0.0726023 14.1614 0.220546 13.8689L6.52816 7.57397L0.220548 1.281C-0.0725348 0.988557 -0.0735821 0.513696 0.218595 0.220451Z" fill="#19191C"/></svg>';

      var html = "";
      html += '<div class="supra-page-arrow supra-page-prev' + (currentPage <= 1 ? " disabled" : "") + '">' + ARROW_SVG + '</div>';
      $.each(getPageNumbers(currentPage, totalPages), function (_, p) {
        if (p === "...") {
          html += '<span class="supra-page-ellipsis">…</span>';
        } else {
          html +=
            '<button class="supra-page-btn' + (p === currentPage ? " active" : "") + '" data-page="' + p + '">' + p + "</button>";
        }
      });
      html += '<div class="supra-page-arrow supra-page-next' + (currentPage >= totalPages ? " disabled" : "") + '">' + ARROW_SVG + '</div>';
      $el.html(html);
    }
  
    function renderReviews(reviews) {
      var $container = $("#supa-reviews-list");
      if (!$container.length) return;
      $container.html(reviews && reviews.length ? $.map(reviews, renderReview).join("") : "");
    }
  
    function goToPage(page) {
      currentPage = page;
      renderPagination();
      fetchPage(currentRating, page).then(function (reviews) {
        renderReviews(reviews);
        var $el = $(".pdp_supa-reviews");
        if ($el.length) {
          $("html, body").animate({ scrollTop: $el.offset().top - 200 }, 300);
        }
      });
    }
  
    function loadReviews(rating) {
      currentRating = rating;
      currentPage = 1;
      var reqLocalCount = localFirst ? fetchCount(rating, localParams(true)) : $.Deferred().resolve(0).promise();
      $.when(fetchCount(rating), reqLocalCount)
        .then(function (total, local) {
          localCount = local || 0;
          updateLocalNotice(rating, total);
          totalPages = Math.ceil(total / PAGE_SIZE) || 1;
          renderPagination();
          return fetchPage(rating, 1);
        })
        .then(renderReviews);
    }

    // Notice when "Show UK reviews first" is on but the current view has 0 local reviews —
    // also on load / "All". One text for every case: Theme settings → trans_local_first_empty
    // ([rating], [count]). With "All" there is no star value, so "[rating]-star " is dropped
    // ("No [rating]-star reviews…" → "No reviews…").
    function updateLocalNotice(rating, total) {
      var $notice = $("[data-local-first-notice]");
      if (!$notice.length) return;
      var isAll = !rating || rating === "all" || (Array.isArray(rating) && !rating.length);
      var show = localFirst && localCount === 0 && total > 0;
      var tpl = $notice.attr("data-text") || "";
      if (!show || !tpl) {
        $notice.prop("hidden", true);
        return;
      }
      var text;
      if (isAll) {
        text = tpl.replace(/\[rating\]\S*\s*/g, "");
      } else {
        var ratingLabel = Array.isArray(rating) ? rating.slice().sort().reverse().join(", ") : String(rating);
        text = tpl.replace(/\[rating\]/g, ratingLabel);
      }
      $notice.find(".pdp_local-first-notice__text").text(
        text.replace(/\[count\]/g, String(total)).replace(/\s{2,}/g, " ").trim()
      );
      $notice.prop("hidden", false);
    }

    // "Show UK reviews first" toggle — desktop + mobile instances stay in sync
    function setLocalFirst(on) {
      localFirst = on;
      $("[data-local-first-toggle]").toggleClass("active", on).attr("aria-checked", on ? "true" : "false");
      loadReviews(currentRating);
    }
    $(document).on("click", "[data-local-first-toggle]", function () {
      setLocalFirst(!localFirst);
    });
    $(document).on("keydown", "[data-local-first-toggle]", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setLocalFirst(!localFirst);
      }
    });
  
    function updateApplyBtnCount() {
      var activeStars = [];
      $(".overall-rating_filter_line.active").each(function () {
        var val = $(this).attr("data");
        if (val && val !== "all") activeStars.push(val);
      });
      var count;
      if (activeStars.length === 0) {
        count = totalReviewCount;
      } else {
        count = 0;
        $.each(activeStars, function (_, r) { count += starCounts[r] || 0; });
      }
      var label = $(".filter__rsp-apply-btn").data("label") || "Apply";
      $(".filter__rsp-apply-btn .btn__text").text(label + " (" + count + ")");
    }
    window.updateApplyBtnCount = updateApplyBtnCount;

    function initRatingCounts() {
      var starRatings = ["5", "4", "3", "2", "1"];

      function updateBars() {
        var total = 0;
        $.each(starRatings, function (_, r) { total += starCounts[r] || 0; });
        if (total === 0) return;
        $.each(starRatings, function (_, r) {
          var pct = Math.round((starCounts[r] || 0) / total * 100);
          $(".overall-rating_filter_line[data='" + r + "'] .overall-rating-fill-bar_inner").css("width", pct + "%");
          $(".pdp_rating_tooltip-stars-line[data='" + r + "'] .pdp_rating_tooltip-stars-line-bar_fill").css("width", pct + "%");
        });
        updateApplyBtnCount();
      }

      applyTotalCount(parseInt($reviewsEl.attr("data-review-count"), 10) || 0);

      function applyTotalCount(count) {
        totalReviewCount = count;
        var $line = $(".overall-rating_filter_line[data='all']");
        $line.find(".overall-rating_info__count").text(count);
        var countLabel = (window.reviewStrings && window.reviewStrings.countLabel) || $(".reviews-pdp-dynamic-copies").data("count-label") || "";
        var countText = countLabel ? countLabel.replace("[count]", count) : count;
        $(".main_product_rating_actual__js").each(function () {
          $(this).html($(this).hasClass("main_pdp-reviews") ? "(" + countText + ")" : countText);
        });
        $(".product-overall_rating-stars").find("p span").html(count);
        var verifiedLabel = $(".reviews-pdp-dynamic-copies").data("verified-count-label") || "";
        $(".reviews-summary_count_label__text").html(verifiedLabel ? verifiedLabel.replace("[count]", count) : count);
      }

      function readStarCounts() {
        try {
          return JSON.parse($reviewsEl.attr("data-review-stars") || "{}") || {};
        } catch (e) {
          return {};
        }
      }

      function applyStarCount(rating, count) {
        var $line = $(".overall-rating_filter_line[data='" + rating + "']");
        $line.find(".overall-rating_info__count").text(count);
        if (count === 0) $line.addClass("disabled");
        $(".pdp_rating_tooltip-stars-line[data='" + rating + "'] .pdp_rating_tooltip-stars-line-right p").text(count);
        starCounts[rating] = count;
      }

      var storedStars = readStarCounts();
      $.each(starRatings, function (_, rating) {
        applyStarCount(rating, parseInt(storedStars[rating], 10) || 0);
      });
      updateBars();
    }
  
    function initFilters() {
      var selectedRatings = [];

      $(document).on("click", ".overall-rating_filter_line", function () {
        if ($(this).hasClass("disabled")) return;
        var val = $(this).attr("data");
        var $allLine = $(".overall-rating_filter_line[data='all']");

        if (val === "all") {
          selectedRatings = [];
          $(".overall-rating_filter_line").removeClass("active");
          $allLine.addClass("active");
          loadReviews("all");
          updateApplyBtnCount();
          return;
        }

        $allLine.removeClass("active");

        var idx = selectedRatings.indexOf(val);
        if (idx === -1) {
          selectedRatings.push(val);
          $(this).addClass("active");
        } else {
          selectedRatings.splice(idx, 1);
          $(this).removeClass("active");
        }

        if (selectedRatings.length === 0) {
          $allLine.addClass("active");
          loadReviews("all");
        } else {
          loadReviews(selectedRatings.slice());
        }
        updateApplyBtnCount();
      });
    }
  
    $(document).on("click", ".supra-page-btn", function () {
      goToPage(parseInt($(this).attr("data-page"), 10));
    });

    $(document).on("click", ".supra-page-prev", function () {
      if ($(this).hasClass("disabled")) return;
      if (currentPage > 1) goToPage(currentPage - 1);
    });

    $(document).on("click", ".supra-page-next", function () {
      if ($(this).hasClass("disabled")) return;
      if (currentPage < totalPages) goToPage(currentPage + 1);
    });
  
    // ── Gallery slider arrows ──────────────────────────────────────────────────
  
    $(document).on("click", ".pdp_supa-reviews-nav.nextArr", function () {
      if ($(this).hasClass("disabledsup")) return;
      scrollGalleryToIndex(gallerySliderIndex + 1);
    });
  
    $(document).on("click", ".pdp_supa-reviews-nav.prevArr", function () {
      if ($(this).hasClass("disabledsup")) return;
      scrollGalleryToIndex(gallerySliderIndex - 1);
    });
  
    // ── Translate / revert buttons ─────────────────────────────────────────────
  
    $(document).on("click", ".rsp_popup-translate-btn", function () {
      var $btn       = $(this);
      var $btns      = $btn.closest(".rsp_popup-translate_btns");
      var $container = $btn.closest(".pdp_supa-review, .rsp_popup-review-content");
      $btns.find(".rsp_popup-loading-btn").hide();
      $btn.hide();
      $btns.find(".rsp_popup-revert-btn").css("display", "inline-block");
      $container.find(".originalCont").hide();
      $container.find(".translatedCont").show();
    });

    $(document).on("click", ".rsp_popup-revert-btn", function () {
      var $btn       = $(this);
      var $btns      = $btn.closest(".rsp_popup-translate_btns");
      var $container = $btn.closest(".pdp_supa-review, .rsp_popup-review-content");
      $btns.find(".rsp_popup-loading-btn").hide();
      $btn.hide();
      $btns.find(".rsp_popup-translate-btn").css("display", "inline-block");
      $container.find(".translatedCont").hide();
      $container.find(".originalCont").show();
    });
  
    function renderPopupContent(data) {
      var origText  = data.origText  || "";
      var transText = data.transText || "";
      var loc       = data.city || data.location || "";
      var html      = "";
      if (transText) {
        html += '<p class="translatedCont">' + transText + "</p>";
        html += '<p class="originalCont">' + origText + "</p>";
      } else {
        html += "<p>" + origText + "</p>";
      }
      var realTranslation = (transText && differs(transText, origText)) ||
                            (data.transTitle && differs(data.transTitle, data.origTitle));
      if (realTranslation && reviewNeedsTranslate(data.language || "", loc)) {
        html += TRANSLATE_BTNS_HTML;
      }
      return html;
    }

    function renderPopupTitle(data) {
      var origTitle  = data.origTitle  || "";
      var transTitle = data.transTitle || "";
      var loc        = data.city || data.location || "";
      if (!origTitle && !transTitle) return "";
      // Split into translated/original so the title swaps in sync with the text
      if (transTitle && reviewNeedsTranslate(data.language || "", loc)) {
        return '<span class="translatedCont">' + transTitle + "</span>" +
               '<span class="originalCont">' + origTitle + "</span>";
      }
      return origTitle || transTitle;
    }
  
    // ── Popup ──────────────────────────────────────────────────────────────────
  
    var galleryReviews     = [];
    var galleryReviewIndex = -1;
    var gallerySliderIndex  = 0;
    var popupMedia          = [];
    var popupIndex          = 0;
    var popupImageGen       = 0;
    var thumbsScrollTarget  = 0;
    var popupReviewId       = null;
    var popupReviewVotes    = 0;
  
    function updateMainArrows() {
      var $popup = $(".rsp_popup-outer");
      if (!$popup.length) return;
  
      var hasGalleryItems = nextReviewWithMedia(0) !== -1;
      var hasPrevReview = galleryReviewIndex >= 0 ? prevReviewWithMedia(galleryReviewIndex - 1) !== -1 : hasGalleryItems;
      var hasNextReview = galleryReviewIndex >= 0 ? nextReviewWithMedia(galleryReviewIndex + 1) !== -1 : hasGalleryItems;
      var canNavigate   = popupMedia.length > 1 || hasPrevReview || hasNextReview;
      $popup.find(".rsp_popup-media-arrow__left").toggle(popupMedia.length > 0 && canNavigate);
      $popup.find(".rsp_popup-media-arrow__right").toggle(popupMedia.length > 0 && canNavigate);
  
      var reviewsWithMedia = 0;
      $.each(galleryReviews, function (_, r) { if (getMediaItems(r).length) reviewsWithMedia++; });
      $popup.find(".rsp_popup-thumbs-arrow__left, .rsp_popup-thumbs-arrow__right").toggle(reviewsWithMedia > 1);
    }
  
    function setPopupImage(index) {
      var $popup = $(".rsp_popup-outer");
      if (!$popup.length) return;
  
      var $existingVideo = $popup.find(".rsp_popup-video-el");
      if ($existingVideo.length) {
        $existingVideo[0].pause();
        $existingVideo[0].currentTime = 0;
        $existingVideo.prop("muted", true).removeAttr("controls");
        $popup.find(".rsp_popup-video-wrap").hide().removeClass("playing");
        $popup.find(".rsp_popup-video-play-btn").show();
      }
  
      popupIndex = index;
      var item = popupMedia[index];
      if (!item) return;
  
      if (item.type === "video") {
        if (!$popup.find(".rsp_popup-video-wrap").length) {
          $popup.find(".rsp_popup-main-image__src").after(
            '<div class="rsp_popup-video-wrap">' +
              '<video class="rsp_popup-video-el" preload="metadata" muted playsinline></video>' +
              '<div class="rsp_popup-video-play-btn">' + POPUP_PLAY_ICON_SVG + '</div>' +
            '</div>'
          );
        }
        var $videoWrap = $popup.find(".rsp_popup-video-wrap");
        var $videoEl   = $videoWrap.find(".rsp_popup-video-el");
        $popup.find(".rsp_popup-main-image__src").css("visibility", "hidden");
        $videoWrap.css("display", "flex").removeClass("playing");
        $videoWrap.find(".rsp_popup-video-play-btn").show();
        $videoEl.attr("src", item.url).prop("muted", true).removeAttr("controls");
        $videoEl[0].load();
        $videoEl[0].currentTime = 0.001;
      } else {
        $popup.find(".rsp_popup-video-wrap").hide();
        var $img = $popup.find(".rsp_popup-main-image__src");
        $img.css("visibility", "").attr("src", thumbUrl(item.url)).addClass("loadingImage");
        var myGen = ++popupImageGen;
        var hi = new Image();
        hi.onload = function () {
          if (popupImageGen !== myGen) return;
          $img.attr("src", item.url).removeClass("loadingImage");
        };
        hi.src = item.url;
      }
  
      var hasGalleryItems = nextReviewWithMedia(0) !== -1;
      var hasPrev = galleryReviewIndex > 0 ? prevReviewWithMedia(galleryReviewIndex - 1) !== -1 : (galleryReviewIndex < 0 && hasGalleryItems);
      var hasNext = galleryReviewIndex >= 0 ? nextReviewWithMedia(galleryReviewIndex + 1) !== -1 : hasGalleryItems;
      $popup.find(".rsp_popup-media-arrow__left").toggleClass("disabledArrowMain", index <= 0 && !hasPrev);
      $popup.find(".rsp_popup-media-arrow__right").toggleClass("disabledArrowMain", index >= popupMedia.length - 1 && !hasNext);
    }
  
    function buildPopupGallery(activeIndex) {
      var $popup = $(".rsp_popup-outer");
      if (!$popup.length) return;
      var $strip = $popup.find(".rsp_popup-thumbnails_gallery");
      if (!$strip.length) return;
  
      $strip.html(
        $.map(galleryReviews, function (r, i) {
          var items = getMediaItems(r);
          if (!items.length) return null;
          var first = items[0];
          var thumbContent = first.type === "video"
            ? '<div class="rsp_popup-gallery-video-thumb">' +
                '<video src="' + first.url + '" muted preload="metadata" playsinline></video>' +
                '<div class="rsp_popup-gallery-play-icon">' + PLAY_ICON_SVG + '</div>' +
              '</div>'
            : '<img loading="lazy" decoding="async" src="' + thumbUrl(first.url) + '" alt="">';
          return (
            '<div class="rsp_popup-gallery-review' + (i === activeIndex ? " active" : "") + '" data-gallery-index="' + i + '">' +
              thumbContent +
            "</div>"
          );
        }).join("")
      );
  
      $strip.find("video").each(function () {
        var v = this;
        if (v.readyState >= 1) {
          v.currentTime = 0.001;
        } else {
          $(v).on("loadedmetadata", function () { v.currentTime = 0.001; });
        }
      });
    }
  
    function setPopupReview(index, goToLast) {
      if (index < 0 || index >= galleryReviews.length) return;
      var r = galleryReviews[index];
      var items = getMediaItems(r);
      if (!items.length) return;
  
      galleryReviewIndex = index;
      popupMedia = items;
      popupReviewId    = r.id    != null ? String(r.id)            : null;
      popupReviewVotes = r.votes != null ? parseInt(r.votes, 10)   : 0;
  
      var $popup = $(".rsp_popup-outer");
      if (!$popup.length) return;
      $popup.find(".rsp_popup-main-image__src").addClass("loadingImage");
  
      var rating = Math.min(Math.max(Math.round(r.rating) || 0, 1), 5);
      $popup.find(".rsp_popup-days").text(timeAgo(r.date_created) || "");
      $popup.find(".rsp_popup-name").text(r.author || "");
      $popup.find(".rsp-popup_review-title").html(renderPopupTitle({
        origTitle:  r.review_title || "",
        transTitle: r[TRANS_TITLE]  || "",
        city:       r.location      || "",
        language:   r.language      || "",
      })).toggle(!!(r.review_title || r[TRANS_TITLE]));
      var popupCountry = countryLabel(r.location, r.language, r.store);
      $popup.find(".rso_popup-country")
        .html(countryHtml(popupCountry, r.language, r.country_names))
        .toggle(!!popupCountry);
      $popup.find(".rsp-popup_review_content").html(renderPopupContent({
        origText:   r.comments     || "",
        transText:  r[TRANS_TEXT]  || "",
        origTitle:  r.review_title || "",
        transTitle: r[TRANS_TITLE] || "",
        city:       r.location     || "",
        language:   r.language     || "",
      }));
      $popup.find(".rsp-popup_stars").html(
        STAR_IMGS[rating] ? '<img src="' + STAR_IMGS[rating] + '" alt="">' : ""
      );
  
      $popup.find(".rsp_popup-gallery-review").each(function () {
        var cellIndex = parseInt($(this).attr("data-gallery-index"), 10);
        $(this).toggleClass("active", cellIndex === index);
        if (cellIndex === index) {
          var outer = $(this).closest(".rsp_popup-thumbnails_gallery--outer")[0];
          if (outer) {
            outer.scrollLeft = this.offsetLeft - outer.offsetWidth / 2 + this.offsetWidth / 2;
          }
        }
      });
  
      setPopupImage(goToLast ? items.length - 1 : 0);
      updateMainArrows();
      updateHelpfulBtn();
    }
  
    function closePopup() {
      var $p = $(".rsp_popup-outer");
      if (!$p.length) return;
      var $videoEl = $p.find(".rsp_popup-video-el");
      if ($videoEl.length) {
        $videoEl[0].pause();
        $videoEl[0].currentTime = 0;
        $videoEl.prop("muted", true).removeAttr("controls");
        $p.find(".rsp_popup-video-wrap").hide().removeClass("playing");
        $p.find(".rsp_popup-video-play-btn").show();
      }
      $p.find(".rsp_popup-main-image__src").css("visibility", "");
      $p.hide();
      window.unlockScroll();
      $p.find(".rsp_popup-review-info").removeClass("loaded");
      $p.removeAttr("data-supa-source");
    }
  
    function openPopup(media, startIndex, meta, reviewIndex) {
      var $popup = $(".rsp_popup-outer");
      if (!$popup.length) return;
      window.lockScroll();
      $popup.find(".rsp_popup-main-image__src").addClass("loadingImage");
  
      popupMedia = media;
      galleryReviewIndex = reviewIndex !== undefined ? reviewIndex : -1;
      popupReviewId    = meta.id    != null ? String(meta.id)          : null;
      popupReviewVotes = meta.votes != null ? parseInt(meta.votes, 10) : 0;
      if (popupReviewId === null && galleryReviewIndex >= 0 && galleryReviews[galleryReviewIndex]) {
        var gr = galleryReviews[galleryReviewIndex];
        popupReviewId    = gr.id    != null ? String(gr.id)    : null;
        popupReviewVotes = parseInt(gr.votes, 10) || 0;
      }
  
      $popup.find(".rsp_popup-days").text(meta.date || "");
      $popup.find(".rsp_popup-name").text(meta.name || "");
      // Country (+ flag) — openPopup never set it, so it showed the previous review's value or stayed empty
      var gRev = galleryReviewIndex >= 0 ? galleryReviews[galleryReviewIndex] : null;
      var popupLang = meta.language || (gRev && gRev.language) || "";
      var popupCity = countryLabel(meta.city || (gRev && gRev.location) || "", popupLang, gRev && gRev.store);
      $popup.find(".rso_popup-country")
        .html(countryHtml(popupCity, popupLang, meta.countryNames || (gRev && gRev.country_names)))
        .toggle(!!popupCity);
      $popup.find(".rsp-popup_review-title").html(renderPopupTitle({
        origTitle:  meta.origTitle  || "",
        transTitle: meta.transTitle || "",
        city:       meta.city       || "",
        language:   popupLang,
      })).toggle(!!(meta.origTitle || meta.transTitle));
      $popup.find(".rsp-popup_review_content").html(renderPopupContent({
        origText:   meta.origText   || meta.text || "",
        transText:  meta.transText  || "",
        origTitle:  meta.origTitle  || "",
        transTitle: meta.transTitle || "",
        city:       meta.city       || "",
        language:   meta.language   || "",
      }));
      $popup.find(".rsp-popup_stars").html(
        meta.rating && STAR_IMGS[meta.rating] ? '<img src="' + STAR_IMGS[meta.rating] + '" alt="">' : ""
      );
  
      thumbsScrollTarget = 0;
      buildPopupGallery(galleryReviewIndex);
      setPopupImage(startIndex);
      updateMainArrows();
      updateHelpfulBtn();
  
      $popup.attr("data-supa-source", "true");
      $popup.find(".rsp_popup-review-info").removeClass("loaded");
      $popup.css("display", "flex");
      setTimeout(function () {
        $popup.find(".rsp_popup-review-info").addClass("loaded");
      }, 200);
    }
  
    function nextReviewWithMedia(fromIndex) {
      for (var i = fromIndex; i < galleryReviews.length; i++) {
        if (getMediaItems(galleryReviews[i]).length) return i;
      }
      return -1;
    }
  
    function prevReviewWithMedia(fromIndex) {
      for (var i = fromIndex; i >= 0; i--) {
        if (getMediaItems(galleryReviews[i]).length) return i;
      }
      return -1;
    }
  
    function updateHelpfulBtn() {
      var $popup = $(".rsp_popup-outer");
      if (!$popup.length) return;
      var voted = !!(popupReviewId && getVotedSet().has(String(popupReviewId)));
      $popup.find(".rsp-popup_helpful").toggleClass("voted", voted);
      $popup.find(".rsp-popup_helpful-btn").toggleClass("liked", voted);
      $popup.find(".rsp-popup_helpful p").text(voted ? UPVOTED : POPUP_HELPFUL);
    }
  
    function initPopup() {
      if (!$(".rsp_popup-outer").length) return;
  
      $(document).on("click", ".rsp_popup-media-arrow__right", function () {
        if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
        if ($(this).hasClass("disabledArrowMain")) return;
        if (popupIndex < popupMedia.length - 1) {
          setPopupImage(popupIndex + 1);
        } else {
          var next = galleryReviewIndex >= 0
            ? nextReviewWithMedia(galleryReviewIndex + 1)
            : nextReviewWithMedia(0);
          if (next !== -1) setPopupReview(next);
        }
      });
  
      $(document).on("click", ".rsp_popup-media-arrow__left", function () {
        if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
        if ($(this).hasClass("disabledArrowMain")) return;
        if (popupIndex > 0) {
          setPopupImage(popupIndex - 1);
        } else {
          var prev = galleryReviewIndex >= 0
            ? prevReviewWithMedia(galleryReviewIndex - 1)
            : prevReviewWithMedia(galleryReviews.length - 1);
          if (prev !== -1) setPopupReview(prev, true);
        }
      });
  
      $(document).on("click", ".rsp_popup-thumbs-arrow__right", function () {
        if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
        var outer = $(".rsp_popup-thumbnails_gallery--outer")[0];
        if (!outer) return;
        thumbsScrollTarget = Math.min(thumbsScrollTarget + 184, outer.scrollWidth - outer.clientWidth);
        outer.scrollLeft = thumbsScrollTarget;
      });
  
      $(document).on("click", ".rsp_popup-thumbs-arrow__left", function () {
        if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
        var outer = $(".rsp_popup-thumbnails_gallery--outer")[0];
        if (!outer) return;
        thumbsScrollTarget = Math.max(thumbsScrollTarget - 184, 0);
        outer.scrollLeft = thumbsScrollTarget;
      });
  
      $(document).on("click", ".rsp_popup-gallery-review", function () {
        if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
        setPopupReview(parseInt($(this).attr("data-gallery-index"), 10));
      });
  
      $(document).on("click", ".rsp_popup-close", function () {
        closePopup();
      });
  
      $(document).on("click", ".rsp_popup-outer", function (e) {
        if (!$(e.target).closest(".rsp_popup-inner").length) {
          e.stopImmediatePropagation();
          closePopup();
        }
      });
  
      $(document).on("keydown", function (e) {
        if (e.key === "Escape") closePopup();
      });
  
      $(document).on("click", ".R-MediaSlider__item--reviewPhoto, .R-PhotoVideoThumbnail", function () {
        $(".rsp_popup-outer").removeAttr("data-supa-source");
      });
  
      $(document).on("click", ".rsp-popup_helpful-btn", function () {
        if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
        var $helpful = $(this).closest(".rsp-popup_helpful");
        if ($helpful.hasClass("voted") || !popupReviewId) return;
        var id = popupReviewId;
        var newCount = popupReviewVotes + 1;
        $.ajax({
          url: SUPABASE_URL + "/rest/v1/" + encodeURIComponent("Reviews.io Original data") + "?id=eq." + id,
          method: "PATCH",
          headers: $.extend({}, SUPABASE_HEADERS, { Prefer: "return=minimal" }),
          contentType: "application/json",
          data: JSON.stringify({ votes: newCount }),
        }).done(function () {
          markVoted(id);
          popupReviewVotes = newCount;
          updateHelpfulBtn();
          var $card = $(".pdp_supa-review-rate-review[data-review-id='" + id + "']");
          if ($card.length) {
            $card.find("span:last").text(newCount);
            $card.closest(".pdp_supa-review-social").addClass("voted").find("div:first p").text(UPVOTED);
          }
        });
      });
  
      $(document).on("click", ".pdp_supa-reviews-gallery-cell", function () {
        var $cell = $(this);
        var media = [];
        try { media = JSON.parse($cell.attr("data-media") || "[]"); } catch (_) {}
        var gIdx = parseInt($cell.attr("data-gallery-index"), 10);
        openPopup(media, 0, {
          name:       $cell.attr("data-name")        || "",
          date:       $cell.attr("data-date")        || "",
          text:       $cell.attr("data-text")        || "",
          origText:   $cell.attr("data-text")        || "",
          transText:  $cell.attr("data-trans-text")  || "",
          origTitle:  $cell.attr("data-title")       || "",
          transTitle: $cell.attr("data-trans-title") || "",
          city:       $cell.attr("data-city")        || "",
          language:   $cell.attr("data-language")    || "",
          rating:     parseInt($cell.attr("data-rating"), 10) || 0,
        }, isNaN(gIdx) ? -1 : gIdx);
      });
  
      $(document).on("click", ".rsp_popup-video-play-btn", function () {
        if (!$(".rsp_popup-outer").attr("data-supa-source")) return;
        var $wrap = $(this).closest(".rsp_popup-video-wrap");
        var video = $wrap.find(".rsp_popup-video-el")[0];
        if (!video) return;
        $(this).hide();
        $wrap.addClass("playing");
        video.muted = false;
        video.currentTime = 0;
        video.setAttribute("controls", "");
        video.play();
      });
  
      $(document).on("click", ".pdp_supa-reviews-media img", function () {
        var $img    = $(this);
        var $media  = $img.closest(".pdp_supa-reviews-media");
        var $all    = $media.find("img");
        var media   = $all.map(function () { return { type: "image", url: this.src }; }).get();
        var idx     = $all.index($img);
        var $review = $img.closest(".pdp_supa-review");
        var reviewId = $review.attr("data-review-id");
        var gIdx = -1;
        if (reviewId) {
          $.each(galleryReviews, function (i, r) {
            if (String(r.id) === String(reviewId)) { gIdx = i; return false; }
          });
        }
        var $origTextEl   = $review.find(".pdp_supa-review-text.originalCont p");
        var $transTextEl  = $review.find(".pdp_supa-review-text.translatedCont p");
        var $origTitleEl  = $review.find(".pdp_supa-review-title.originalCont");
        var $transTitleEl = $review.find(".pdp_supa-review-title.translatedCont");
        openPopup(media, idx < 0 ? 0 : idx, {
          name:       $review.find(".pdp_supa-review-name").text().trim(),
          // review has 2 dates (Mobile_only + desktop) → take one, otherwise text() joins both
          date:       $review.find(".pdp_supa-review-date").first().text().trim(),
          origText:   $origTextEl.length  ? $origTextEl.text().trim()  : $transTextEl.text().trim(),
          transText:  $origTextEl.length  ? $transTextEl.text().trim() : "",
          origTitle:  $origTitleEl.length ? $origTitleEl.text().trim() : $transTitleEl.text().trim(),
          transTitle: $origTitleEl.length ? $transTitleEl.text().trim() : "",
          city:       $review.find(".pdp_supa-review-country").attr("data-label") || "",
          countryNames: (function () { try { return JSON.parse($review.find(".pdp_supa-review-country").attr("data-names") || "null"); } catch (e) { return null; } }()),
          language:   $review.attr("data-language") || "",
          rating:     parseInt($review.attr("data-rating"), 10) || 0,
          id:         reviewId || "",
          votes:      parseInt($review.find(".pdp_supa-review-rate-review span:last").text(), 10) || 0,
        }, gIdx);
      });
    }
  
    // ── Init ───────────────────────────────────────────────────────────────────
  
    if ($("#supa-reviews-list").length) {
      $('<div id="supra-reviews-pagination" class="supra-reviews-pagination">').insertAfter("#supa-reviews-list");
    }
  
    var galleryScrollTimer;
    $(".pdp_supa-reviews-gallery-wrapper").on("scroll", function () {
      clearTimeout(galleryScrollTimer);
      var $wrapper = $(this);
      galleryScrollTimer = setTimeout(function () {
        var scrollLeft = $wrapper.scrollLeft();
        var $cells = $(".pdp_supa-reviews-gallery-cell");
        var closest = 0;
        var closestDist = Infinity;
        $cells.each(function (i) {
          var cellLeft = $(this).offset().left - $wrapper.offset().left + scrollLeft;
          var dist = Math.abs(cellLeft - scrollLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        gallerySliderIndex = closest;
        updateGalleryArrows();
      }, 50);
    });
  
    loadReviews("all");
    initFilters();
    initRatingCounts();
    initPopup();
    fetchGalleryReviews().then(renderGallery);
  
  
    var $sortBackdrop = $('<div id="pdp-sort-backdrop" style="position:fixed;top:0;left:0;width:100%;height:100%;z-index:8;"></div>');
  
    function closeSortDropdown() {
      $(".pdp_sr-sort").removeClass("active");
      $(".pdp_sr-content").slideUp();
      $sortBackdrop.detach();
    }
  
    $(document).on("click", ".pdp_sr-sort", function () {
      var opening = !$(this).hasClass("active");
      $(this).toggleClass("active");
      $(".pdp_sr-content").slideToggle();
      if (opening) {
        $sortBackdrop.appendTo("body").one("click", closeSortDropdown);
      } else {
        $sortBackdrop.detach();
      }
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $(".pdp_sr-sort").hasClass("active")) {
        closeSortDropdown();
      }
    });
  
    $(document).on("click", ".pdp_sr-val", function () {
      var val      = $(this).attr("data");
      var isActive = $(this).hasClass("active");
  
      $(document).off("click.sortClose");
      closeSortDropdown();
  
  
      if (isActive) return;
  
      $(".pdp_sr-val").removeClass("active");
      $(this).addClass("active");
      $(".pdp_sr-sort span:first").text($(this).text().trim());
  
      currentSort = val;
      currentPage = 1;
      renderPagination(); // back to page 1 in the pagination too
      fetchPage(currentRating, 1).then(renderReviews);
    });
  
    $(document).on("click", ".pdp_supa-review-rate-review", function () {
      var $btn    = $(this);
      var reviewId = String($btn.attr("data-review-id"));
      var $social  = $btn.closest(".pdp_supa-review-social");
  
      if ($social.hasClass("voted")) return;
  
      var $countSpan = $btn.find("span:last");
      var newCount   = (parseInt($countSpan.text(), 10) || 0) + 1;
  
      $.ajax({
        url: SUPABASE_URL + "/rest/v1/" + encodeURIComponent("Reviews.io Original data") + "?id=eq." + reviewId,
        method: "PATCH",
        headers: $.extend({}, SUPABASE_HEADERS, { Prefer: "return=minimal" }),
        contentType: "application/json",
        data: JSON.stringify({ votes: newCount }),
      }).done(function () {
        markVoted(reviewId);
        $countSpan.text(newCount);
        $social.addClass("voted");
        $social.find("div:first p").text(UPVOTED);
      });
    });
  
  });